import { SessionType, Consultation, Address } from '@/shared/types/generated';

/**
 * Formats a city string by removing underscores and converting to title case
 */
function formatCity(city: string): string {
  return city
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

/**
 * Formats an address object into a display string
 * Format: "Street Address City, State" (no comma after street, city formatted as title case)
 */
export function formatAddress(address: Address | null | undefined): string {
  if (!address) {
    return 'Address not provided';
  }

  const streetAddress = address.streetAddress || '';
  const city = address.city ? formatCity(address.city) : '';
  const state = address.state || '';

  const cityState = [city, state].filter(Boolean).join(', ');
  const parts = [streetAddress, cityState].filter(Boolean);

  return parts.join(', ') || 'Address not provided';
}

/**
 * Determines if a consultation is an in-person event session
 */
export function isInPersonAtEvent(consultation: Consultation): boolean {
  return consultation.sessionType === SessionType.InPersonEvent;
}

export function isInPersonSession(consultation: Consultation): boolean {
  return consultation.sessionType === SessionType.InPersonSession;
}

/**
 * Determines if a consultation is any type of in-person session (event or regular)
 */
export function isAnyInPersonSession(consultation: Consultation): boolean {
  return (
    consultation.sessionType === SessionType.InPersonEvent ||
    consultation.sessionType === SessionType.InPersonSession
  );
}

/**
 * Determines if a consultation is a regular video session
 */
export function isVideoSession(consultation: Consultation): boolean {
  return consultation.sessionType === SessionType.Video;
}
